import { h } from '@stencil/core';
export class VtoScreenComponent {
  constructor() {
    this.data = undefined;
    this.getData = undefined;
    this.styles = undefined;
    this.handlers = undefined;
    this.handleClick = undefined;
    this.keepPhoto = undefined;
    this.recommendedStyle = {};
  }
  async componentWillLoad() {
    if (this.getData) {
      const mainData = await this.getData();
      this.data = mainData === null || mainData === void 0 ? void 0 : mainData.data;
    }
    this.recommendedStyle = await this.handlers.getRecommendedStyle();
  }
  async componentWillRender() {
    await this.handlers.vtoScreenInit();
    this.recommendedStyle = await this.handlers.getRecommendedStyle();
  }
  render() {
    return (h("div", { class: "container intoBlock" }, h("div", { class: 'content-wrapper' }, h("div", { class: 'inner-block' }, this.data &&
      this.data['elements'].map(obj => {
        if (obj.name === 'aiba-vto-camera') {
          return h("aiba-vto-camera", { handlers: this.handlers, data: obj.data, vtoclass: !this.handlers.getVtoStateObject.showResultPage ? 'showvto' : 'hidevto' });
        }
        if (obj.name === 'aiba-vto-hint' && !this.keepPhoto) {
          return h("aiba-vto-hint", { data: obj.data, handlers: this.handlers, vtoclass: !this.handlers.getVtoStateObject.showResultPage ? 'showvto' : 'hidevto' });
        }
        if (this.recommendedStyle && this.recommendedStyle.length > 0 && this.keepPhoto) {
          if (obj.name === 'aiba-vto-style-wrapper') {
            return h("aiba-vto-style-wrapper", { handlers: this.handlers, data: obj.data, vtoclass: !this.handlers.getVtoStateObject.showResultPage ? 'showvto' : 'hidevto' });
          }
        }
        if ((!this.recommendedStyle || this.recommendedStyle.length === 0) && this.keepPhoto) {
          if (obj.name === 'aiba-navigation-block') {
            return h("aiba-navigation-block", Object.assign({}, obj, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
          }
        }
      })))));
  }
  static get is() { return "aiba-vto-screen"; }
  static get originalStyleUrls() {
    return {
      "$": ["./aiba-vto-screen.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-vto-screen.css"]
    };
  }
  static get properties() {
    return {
      "getData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "get-data",
        "reflect": false
      },
      "styles": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "keepPhoto": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "keep-photo",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "data": {},
      "recommendedStyle": {}
    };
  }
}
//# sourceMappingURL=aiba-vto-screen.js.map
